import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xxl-8",
  style: {"margin-top":"-30px"}
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7" }
const _hoisted_5 = { class: "symbol symbol-200px symbol-lg-150px symbol-fixed position-relative" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex align-items-center mb-2" }
const _hoisted_10 = { class: "text-fprimary fs-2 fw-bolder me-1" }
const _hoisted_11 = { href: "#" }
const _hoisted_12 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_13 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "fw-bolder" }
const _hoisted_17 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2-week fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_19 = { class: "d-flex flex-column" }
const _hoisted_20 = { class: "fw-bolder" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 0,
  class: "d-flex flex-row align-items-center mb-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-workspace fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_24 = { class: "d-flex flex-column" }
const _hoisted_25 = { class: "fw-bolder" }
const _hoisted_26 = { class: "d-flex my-4 align-items-center" }
const _hoisted_27 = { class: "me-3" }
const _hoisted_28 = { class: "d-flex gap-4 mb-6 align-items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "w-250px" }, "Fecha de pago", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "Estado", -1)
const _hoisted_31 = { class: "d-flex gap-2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_btnBack = _resolveComponent("btnBack")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DialogOrderDetail = _resolveComponent("DialogOrderDetail")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_image, {
                class: "w-200px h-200px rounded",
                src: _ctx.evento?.logo,
                fit: 'cover'
              }, null, 8, ["src"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.evento.name), 1),
                  _createElementVNode("a", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t("place")), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.evento?.place), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t("date")), 1),
                    _createElementVNode("span", {
                      innerHTML: _ctx.dateParticipate(_ctx.evento?.startdate, _ctx.evento?.enddate)
                    }, null, 8, _hoisted_21)
                  ])
                ]),
                (_ctx.evento?.modality)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.t("modality")), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.evento?.modality == 'V' ? 'Virtual' : 'Presencial'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_btnBack, {
                    to: `/${_ctx.company?.alias.toLowerCase()}/acreditation`
                  }, null, 8, ["to"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_el_input, {
        modelValue: _ctx.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        placeholder: "Ingrese número de Orden",
        onKeypress: _withKeys(_ctx.getListOrders, ["enter"])
      }, null, 8, ["modelValue", "onKeypress"]),
      _hoisted_29,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.payment_date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payment_date) = $event)),
        class: "w-350px",
        type: "date",
        placeholder: "seleccione",
        "value-format": "YYYY-MM-DD",
        format: "DD/MM/YYYY"
      }, null, 8, ["modelValue"]),
      _hoisted_30,
      _createVNode(_component_el_select, {
        modelValue: _ctx.idState,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.idState) = $event)),
        placeholder: "Select",
        class: "w-400px",
        multiple: "",
        "collapse-tags": "",
        "collapse-tags-tooltip": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "success",
        onClick: _ctx.getListOrders
      }, {
        default: _withCtx(() => [
          _createTextVNode("Buscar")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.listOrders,
      border: "",
      "table-layout": 'auto',
      "scrollbar-always-on": true,
      "highlight-current-row": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "idorder",
          label: "Orden",
          width: "80",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "order_number",
          label: 'Operación'
        }, {
          default: _withCtx(( {row} ) => [
            _createElementVNode("span", null, _toDisplayString(row.idserie) + "-" + _toDisplayString(row.idcorrelative), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "customer",
          label: _ctx.t('Institucion')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "quantity",
          label: _ctx.t('Cantidad')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "import",
          label: _ctx.t('Importe')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "payment_date",
          label: 'Fecha de pago'
        }, {
          default: _withCtx(( {row} ) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.payment_date).format("DD/MM/YYYY")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: 'Fecha de registro'
        }, {
          default: _withCtx(( {row} ) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.created_at).format("DD/MM/YYYY HH:mm:ss")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "mstatus",
          label: _ctx.t('state')
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              class: _normalizeClass(row?.mstatus.params)
            }, _toDisplayString(row?.mstatus?.name), 3)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          width: "120",
          label: _ctx.t('options'),
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: 'Detalles',
                placement: "top"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("i", {
                    class: "bi bi-paypal fs-2 text-hover-primary me-3 cursor-pointer",
                    key: row.idorder,
                    onClick: ($event: any) => (_ctx.openModalDetails(row))
                  }, null, 8, _hoisted_32))
                ]),
                _: 2
              }, 1024),
              (row.mstatus?.id == 1)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "dark",
                    content: _ctx.t('download'),
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("i", {
                        class: "bi bi-file-earmark-pdf-fill fs-2 text-hover-primary me-3 cursor-pointer",
                        key: row.idorder,
                        onClick: ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'invoice', { order: row?.idorder }))
                      }, null, 8, _hoisted_33))
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createVNode(_component_DialogOrderDetail, {
      ref: "DialogOrderDetailRef",
      "item-order": _ctx.itemOrder,
      onOnResponseOrderDetails: _ctx.onResponseOrderDetails
    }, null, 8, ["item-order", "onOnResponseOrderDetails"])
  ], 64))
}